<div class="row">
    <div class="col">
        <label for="warehouse" class="form-label">Producto</label>
        <div class="input-group bg-white rounded">
            <app-input-autocomplete
                [allBorderRadius]="true"
                [inputs]="inputs.product"
                [placeholder]="'Ingresa un Producto'"
                [filterElements]="filterProducts"
                (inputMethod)="writeProduct($event.event)"
                (changeStatus)="checkProduct($event.filterElement)"
                (getTitle)="
                    $event.filterElement.title =
                        $event.filterElement.name
                "
            ></app-input-autocomplete>
        </div>
    </div>
</div>